import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Silesian() {
  return (
    <>
      <DisplayMaster voivodeship="Silesian" />
    </>
  );
}